import { checkPendingOrder } from "../adapters/estimate/estimateAdapters";
// import { thunkClearEstimateData as relocationClearEstimateData } from "../redux/reducers/progress/progressReducer";
// import { thunkClearEstimateData as storageClearEstimateData } from "../redux/reducers/storage_progress/progressReducer";

export const verifyOrderInDB = async (serviceType) => {
  let isOrderOutdated = false;
  if (sessionStorage.getItem("userSessionData") === null) {
    return isOrderOutdated;
  }
  const userSessionData = JSON.parse(sessionStorage.getItem("userSessionData"));
  const userSessionMoveInfoData = JSON.parse(sessionStorage.getItem("move_info"));
  const userId = userSessionData.userId;

  let city_type
  if (userSessionMoveInfoData == null) {
    city_type = ""
  } else {
    city_type = userSessionMoveInfoData.city_type || ""
  }

  if (serviceType === "relocation") {
    const relocationOrderDetails = JSON.parse(
      sessionStorage.getItem("orderDetails")
    );

    if (relocationOrderDetails !== null) {
      const pendingOrderResult = await checkPendingOrder({
        user_id: userId,
        service_type: "relocation",
        city_type: city_type
      });
      if (pendingOrderResult.data.data.length === 0) {
        //   dispatch(relocationClearEstimateData());
        //   history.push("/");
        isOrderOutdated = true;
      } else {
        const estimateId = pendingOrderResult.data.data[0].estimate_id;
        const orderDetails = {
          orderId: estimateId,
          dateCreated: new Date(pendingOrderResult.data.data[0].date_created),
        };
        sessionStorage.setItem("orderDetails", JSON.stringify(orderDetails));
      }
    }
  } else if (serviceType === "storage") {
    const storageOrderDetails = JSON.parse(
      sessionStorage.getItem("storageOrderDetails")
    );
    if (storageOrderDetails !== null) {
      const pendingOrderResult = await checkPendingOrder({
        user_id: userId,
        service_type: "storage",
        city_type: city_type
      });
      if (pendingOrderResult.data.data.length === 0) {
        // dispatch(storageClearEstimateData());
        // history.push("/");
        // isOrderOutdated = true;
      } else {
        const estimateId = pendingOrderResult.data.data[0].estimate_id;
        const orderDetails = {
          orderId: estimateId,
          dateCreated: new Date(pendingOrderResult.data.data[0].date_created),
        };
        sessionStorage.setItem(
          "storageOrderDetails",
          JSON.stringify(orderDetails)
        );
      }
    }
  }
  return isOrderOutdated;
};
